import React from 'react';

export default function EggContacts() {
  return (
    <div>EggContacts</div>
  );
}
